<template>
    <div class="modal fade modern-modal" tabindex="-1" id="CadatroUsuarioCliente" ref="modalCadatroUsuarioCliente">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-modern">
            <div class="modal-content modal-modern-content border-0">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                        data-bs-dismiss="modal"
                        type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>

                <div class="modal-modern-header">
                    <div class="header-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M10 4A4 4 0 0 0 6 8A4 4 0 0 0 10 12A4 4 0 0 0 14 8A4 4 0 0 0 10 4M10 6A2 2 0 0 1 12 8A2 2 0 0 1 10 10A2 2 0 0 1 8 8A2 2 0 0 1 10 6M17 12C16.84 12 16.76 12.08 16.76 12.24L16.5 13.5C16.28 13.68 15.96 13.84 15.72 14L14.44 13.5C14.36 13.5 14.2 13.5 14.12 13.6L13.16 15.36C13.08 15.44 13.08 15.6 13.24 15.68L14.28 16.5V17.5L13.24 18.32C13.16 18.4 13.08 18.56 13.16 18.64L14.12 20.4C14.2 20.5 14.36 20.5 14.44 20.5L15.72 20C15.96 20.16 16.28 20.32 16.5 20.5L16.76 21.76C16.76 21.92 16.84 22 17 22H19C19.08 22 19.24 21.92 19.24 21.76L19.4 20.5C19.72 20.32 20.04 20.16 20.28 20L21.5 20.5C21.64 20.5 21.8 20.5 21.8 20.4L22.84 18.64C22.92 18.56 22.84 18.4 22.76 18.32L21.72 17.5V16.5L22.76 15.68C22.84 15.6 22.92 15.44 22.84 15.36L21.8 13.6C21.8 13.5 21.64 13.5 21.5 13.5L20.28 14C20.04 13.84 19.72 13.68 19.4 13.5L19.24 12.24C19.24 12.08 19.08 12 19 12H17M10 13C7.33 13 2 14.33 2 17V20H11.67C11.39 19.41 11.19 18.77 11.09 18.1H3.9V17C3.9 16.36 7.03 14.9 10 14.9C10.43 14.9 10.87 14.94 11.3 15C11.5 14.36 11.77 13.76 12.12 13.21C11.34 13.08 10.6 13 10 13M18.04 15.5C18.84 15.5 19.5 16.16 19.5 17.04C19.5 17.84 18.84 18.5 18.04 18.5C17.16 18.5 16.5 17.84 16.5 17.04C16.5 16.16 17.16 15.5 18.04 15.5Z" />
                        </svg>
                    </div>
                    <div class="header-text">
                        <h2>{{ dados && dados.dsLogin ? 'Editar usuário' : 'Novo usuário' }}</h2>
                        <p>Preencha os campos para {{ dados && dados.dsLogin ? 'atualizar' : 'cadastrar' }} o usuário do contrato.</p>
                    </div>
                </div>
                <div class="tabs-header d-flex align-items-center justify-content-center px-3 mt-3">
                    <ul class="nav nav-tabs my-2 flex-grow-1" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link"
                                    :class="{ active: abaSelecionada === 'usuario' }"
                                    @click="abaSelecionada = 'usuario'"
                                    type="button">
                                Dados do usuário
                            </button>
                        </li>
                        <li class="nav-item" role="presentation" v-if="usuarioSistema">
                            <button class="nav-link"
                                    :class="{ active: abaSelecionada === 'setor' }"
                                    @click="abaSelecionada = 'setor'"
                                    type="button">
                                Setores do usuário
                            </button>
                        </li>
                    </ul>
                </div>

                <div v-show="abaSelecionada === 'usuario'">
                    <div class="modal-modern-body">
                        <form id="formCadastroUsuarioCliente" v-if="dados" novalidate>
                            <div class="form-grid form-grid-2">
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_dsEmail">E-mail</label>
                                    <input type="email"
                                           class="form-control"
                                           id="CadastroUsuario_Usuarios_dsEmail"
                                           name="usuario.dsEmail"
                                           v-model="usuario.dsEmail"
                                           maxlength="100"
                                           :readonly="dados.dsLogin != null"
                                           required>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_nmUsuario">Nome</label>
                                    <input type="text"
                                           class="form-control"
                                           id="CadastroUsuario_Usuarios_nmUsuario"
                                           name="usuario.nmUsuario"
                                           v-model="usuario.nmUsuario"
                                           maxlength="100"
                                           required>
                                </div>
                            </div>

                            <div class="form-grid form-grid-2">
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_idDepartamento">Departamento</label>
                                    <select class="form-control"
                                            v-model="usuario.idDepartamento"
                                            id="CadastroUsuario_Usuarios_idDepartamento"
                                            required>
                                        <option value="0">Selecione</option>
                                        <option v-for="(item,index) in lstDepartamentos" :key="index" :value="item.idDepartamento">
                                            {{ item.nmDepartamento }}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_idFuncao">Função</label>
                                    <select class="form-control"
                                            v-model="usuario.idFuncao"
                                            id="CadastroUsuario_Usuarios_idFuncao"
                                            required>
                                        <option value="0">Selecione</option>
                                        <option v-for="(item,index) in lstFuncoes" :key="index" :value="item.idFuncao">
                                            {{ item.nmFuncao }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-grid form-grid-2">
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_dsCargo">Cargo</label>
                                    <input type="text"
                                           class="form-control"
                                           id="CadastroUsuario_Usuarios_dsCargo"
                                           name="usuario.dsCargo"
                                           v-model="usuario.dsCargo"
                                           maxlength="100"
                                           required>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_dtNascimento">Data de Nascimento</label>
                                    <vue-mask class="form-control"
                                              id="CadastroUsuario_Usuarios_dtNascimento"
                                              name="usuario.dtNascimento"
                                              v-model="usuario.dtNascimento"
                                              mask="00/00/0000"
                                              :raw="false"
                                              :options="options"
                                              required>
                                    </vue-mask>
                                </div>
                            </div>

                            <div class="form-grid form-grid-2">
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_dsTelefone">Telefone</label>
                                    <vue-mask class="form-control"
                                              id="CadastroUsuario_Usuarios_dsTelefone"
                                              name="usuario.dsTelefone"
                                              v-model="usuario.dsTelefone"
                                              mask="(00)00000-0000"
                                              :raw="false"
                                              :options="optionTelefone"
                                              required>
                                    </vue-mask>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_dsCelular">Celular</label>
                                    <vue-mask class="form-control"
                                              id="CadastroUsuario_Usuarios_dsCelular"
                                              name="usuario.dsCelular"
                                              v-model="usuario.dsCelular"
                                              mask="(00)00000-0000"
                                              :raw="false"
                                              :options="optionCelular"
                                              required>
                                    </vue-mask>
                                </div>
                            </div>

                            <div class="form-grid form-grid-2" v-if="dados.dsLogin == null">
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_dsSenha">Senha</label>
                                    <input type="password"
                                           class="form-control"
                                           id="CadastroUsuario_Usuarios_dsSenha"
                                           name="usuario.dsSenha"
                                           v-model="usuario.dsSenha"
                                           :maxlength="100"
                                           required>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="CadastroUsuario_Usuarios_dsSenhaConfirma">Confirma Senha</label>
                                    <input type="password"
                                           class="form-control"
                                           id="CadastroUsuario_Usuarios_dsSenhaConfirma"
                                           name="usuario.dsSenhaConfirma"
                                           v-model="usuario.dsSenhaConfirma"
                                           :maxlength="100"
                                           required>
                                </div>
                            </div>

                            <div class="admin-card"
                                 v-if="resultConsulta && resultConsulta.clienteUsuario && resultConsulta.clienteUsuario.flSupervisor != 'Sim'">
                                <span class="admin-title">
                                    <i class="fas fa-user-shield me-2"></i>
                                    Permissões do contrato
                                </span>
                                <label class="admin-checkbox-label">
                                    <input type="checkbox"
                                           v-model="usuario.ckb_admin"
                                           true-value="Sim"
                                           false-value="Não"
                                           class="admin-checkbox-input" />
                                    <span class="admin-checkbox-custom"></span>
                                    <span class="admin-checkbox-text">
                                        Administrador do contrato
                                    </span>
                                </label>
                                <small class="admin-checkbox-hint">
                                    Este usuário terá permissões administrativas no sistema.
                                </small>
                            </div>


                        </form>
                    </div>
                </div>

                <div v-show="abaSelecionada === 'setor'">
                    <template v-if="usuarioSistema">
                        <div class="modal-modern-body">
                            <div class="row align-items-center">
                                <div class="col-6">
                                    <h4 data-v-4eba2f6f="" class="permissoes-title">
                                        <i class="fas fa-building"></i> Setores do usuário
                                    </h4>
                                </div>
                                <div class="col-6 d-flex align-items-center">
                                    <select class="form-control mb-0"
                                            v-model="idSetor"
                                            id="idSetor">
                                        <option value="0">Selecione</option>
                                        <option v-for="(item,index) in lstSetor" :key="index" :value="item.idSetor">
                                            {{ item.nmSetor }}
                                        </option>
                                    </select>
                                    <button class="ms-2 btn-action btn-edit" type="button" @click="addUsuarioSetor">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="table-wrapper modern-table mt-3">
                                <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100" style="min-width: 100%">
                                    <thead v-if="lstUsuarioSetor">
                                        <tr>
                                            <th class="text-center">Código</th>
                                            <th class="text-center">Nome</th>
                                            <th class="text-center" style="width: 1%">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(registro, index) in lstUsuarioSetor" :key="index">

                                            <td data-label="cdSetor" class="text-center">
                                                <span class="user-badge">{{ registro.cdSetor }}</span>
                                            </td>
                                            <td data-label="nmSetor" class="text-center">
                                                <span class="user-badge">{{ registro.nmSetor }}</span>
                                            </td>
                                            <td data-label="Ações" class="text-center action-cell">
                                                <div class="action-buttons">
                                                    <button @click="excluirUsuarioSetor(registro.idUsuarioSetor)"
                                                            class="action-btn action-btn-delete"
                                                            type="button"
                                                            title="Excluir Setor Usuário">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                        </svg>
                                                        Remover
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="lstUsuarioSetor.length === 0">
                                            <td :colspan="3" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h3 class="empty-title">Usuário não possui setores</h3>
                                                    <p class="empty-description">Selecione um setor e utilize o botão “+” para adicionar um setor ao usuário.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </template>
                </div>



                <div class="modal-modern-footer">
                    <button class="btn btn-primary btn-modern-primary w-100"
                            type="button"
                            :disabled="!liberaSalvar"
                            @click="enviar">
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vueMask from 'vue-jquery-mask'
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'CadatroUsuarioCliente',
        components: {
            vueMask,
        },
        data: function () {
            return {

                limiteCaracteres: 500,
                resultConsulta: null,
                usuario: {
                    nmUsuario: null,
                    dsEmail: null,
                    dsTelefone: null,
                    dsCelular: null,
                    dtNascimento: null,
                    idDepartamento: 0,
                    idFuncao: 0,
                },

                usuarioSistema: null,
                lstSetor: [],
                lstUsuarioSetor: [],
                idSetor: 0,
                contIdUsuarioSetor: 0,
                abaSelecionada: 'usuario',

                lstDepartamentos: [],
                lstFuncoes: [],

                options: {
                    placeholder: '__/__/____',
                },
                optionTelefone: {
                    placeholder: '(__)_____- ____',
                },
                optionCelular: {
                    placeholder: '(__)_____- ____',
                },

                modal: null,
            }
        },
        props: {
            showModal: Boolean,
            dados: Object,
        },
        computed: {
            liberaSalvar() {
                if (this.usuario.dsEmail == '' || this.usuario.dsEmail == null) {
                    return false;
                }

                if (this.usuario.nmUsuario == '' || this.usuario.nmUsuario == null) {
                    return false;
                }

                if (this.usuario.idDepartamento == '' || this.usuario.idDepartamento == null) {
                    return false;
                }

                if (this.usuario.idFuncao == '' || this.usuario.idFuncao == null) {
                    return false;
                }

                if (this.usuario.dsCargo == '' || this.usuario.dsCargo == null) {
                    return false;
                }

                if (this.usuario.dtNascimento == '' || this.usuario.dtNascimento == null) {
                    return false;
                }

                if (this.usuario.dsTelefone == '' || this.usuario.dsTelefone == null) {
                    return false;
                }

                if (this.usuario.dsCelular == '' || this.usuario.dsCelular == null) {
                    return false;
                }

                if (this.dados.dsLogin == null) {
                    if (this.usuario.dsSenha == '' || this.usuario.dsSenha == null) {
                        return false;
                    }
                    if (this.usuario.dsSenhaConfirma == '' || this.usuario.dsSenhaConfirma == null) {
                        return false;
                    }
                }

                return true;
            },

        },        
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    let form = $this.usuario;
                    form.lstFormUsuarioSetor = $this.lstUsuarioSetor;
                    axios.post(`${urlApi}/ClienteContratoProduto/AddUsuarioCliente`, form)
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Dados salvos com sucesso!");
                                $this.modal.hide();

                                $this.$emit('reload');
                                $this.$emit('close');
                            } else {
                                avisoErro("Não foi possível salvar os dados.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                var msg = res.response.data.msg + ' ' + (res.response.data.errors.length > 0 ? res.response.data.errors[0] : '');
                                avisoErro(msg);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                } else {
                    this.abaSelecionada = 'usuario';
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formCadastroUsuarioCliente')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)
                    return false;
                }

                if (this.limiteCaracteres > 0) {
                    if (this.usuario.nmUsuario.length > 100) {
                        avisoErro("O limite de caracteres do \"Nome\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsEmail.length > 100) {
                        avisoErro("O limite de caracteres \"E-mail\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsCargo.length > 100) {
                        avisoErro("O limite de caracteres \"Cargo\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsTelefone.length > 100) {
                        avisoErro("O limite de caracteres \"Telefone\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsCelular.length > 100) {
                        avisoErro("O limite de caracteres \"Celular\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.idDepartamento == 0) {
                        avisoErro("Selecione um \"Departamento\"")
                        return false;
                    }

                    if (this.usuario.idFuncao == 0) {
                        avisoErro("Selecione uma \"Função\"")
                        return false;
                    }
                }

                if (this.usuario.dsSenha != this.usuario.dsSenhaConfirma) {
                    avisoErro("As senhas não são iguais.")
                    return false;
                }
                return true;
            },

            load() {
                let $this = this;
                $this.contIdUsuarioSetor = 0;
                $this.idSetor = 0;
                $this.lstUsuarioSetor = [];

                $this.getSetores();
                axios.get(`${urlApi}/ClienteContratoProduto/GetCadastroUsuarioCliente`, { params: this.dados })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.resultConsulta = result;
                            $this.lstDepartamentos = result.lstDepartamento;
                            $this.lstFuncoes = result.lstFuncao;
                            $this.usuarioSistema = result.usuarioSistema;
                            if ($this.usuarioSistema?.idUsuario) {
                                $this.getSetoresUsuario($this.usuarioSistema.idUsuario);
                            }                            

                            $this.usuario = {
                                tpOperacao: ($this.dados.dsLogin == null ? "Inserir" : "Editar"),
                                idContrato: result.idContrato,
                                idCliente: result.idCliente,
                                nmUsuario: null,
                                dsEmail: null,
                                dsTelefone: "",
                                dsCelular: "",
                                dtNascimento: null,
                                idDepartamento: 0,
                                idFuncao: 0,
                            };
                            if ($this.dados.dsLogin != null && $this.dados.dsLogin != "") {
                                $this.usuario = {
                                    tpOperacao: ($this.dados.dsLogin == null ? "Inserir" : "Editar"),
                                    dsEmail: result.usuarioCRUD.dsEmail,
                                    nmUsuario: result.usuarioCRUD.nmUsuario,
                                    idDepartamento: result.idDepartamento,
                                    idFuncao: result.idFuncao,
                                    dsCargo: result.dsCargo,
                                    dtNascimento: moment(result.usuarioCRUD.dtNascimento).format('DD/MM/YYYY'),
                                    dsTelefone: result.usuarioCRUD.dsTelefone,
                                    dsCelular: result.usuarioCRUD.dsCelular,
                                    ckb_admin: result.clienteUsuario.flAdministrador,
                                    dsSenha: "",
                                    dsSenhaConfirma: "",
                                    idContrato: result.idContrato,
                                    idCliente: result.idCliente,
                                };
                            }
                            
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            getSetores() {
                let $this = this;
                axios.get(`${urlApi}/Setor/Get`)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;

                            $this.lstSetor = result.rows;

                        } else {
                            avisoErro("Não foi possível carregar os setores.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.status == 403) {
                            avisoErro("Você não tem acesso a esse produto.");
                            setTimeout(() => window.location.href = "/Home", 2000);
                        } else {
                            avisoErro(res.response?.data || res.response?.statusText || "Erro ao carregar");
                        }
                    })
                    .finally(() => {
                        $this.isLoading = false;
                    });
            },


            getSetoresUsuario(idUsuario) {
                let $this = this;
                axios.get(`${urlApi}/UsuarioSetor/Get`, { params: { idUsuario: idUsuario } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.lstUsuarioSetor = result.rows;
                        } else {
                            avisoErro("Não foi possível carregar setores do usuário.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            close() {
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadatroUsuarioCliente);
                }
                this.modal.hide();
            },

            excluirUsuarioSetor(idUsuarioSetor) {
                this.lstUsuarioSetor = this.lstUsuarioSetor.filter(function (elm) { return (elm.idUsuarioSetor != idUsuarioSetor) })
            },

            addUsuarioSetor() {
                let $this = this;
                if (!$this.idSetor || $this.idSetor == 0) {
                    avisoErro("Selecione um setor.");
                    return;
                }
                $this.contIdUsuarioSetor++;

                if ($this.lstUsuarioSetor.find(function (elm) { return (elm.idSetor == $this.idSetor) })) {
                    avisoErro("O usuário já possui o setor selecionado.");
                    return;
                }

                var setor = $this.lstSetor.find(function (elm) { return (elm.idSetor == $this.idSetor) })

                if (setor) {
                    this.lstUsuarioSetor.push({
                        idUsuarioSetor: $this.contIdUsuarioSetor,
                        idSetor: setor.idSetor,
                        idUsuario: $this.usuarioSistema.idUsuario,
                        nmSetor: setor.nmSetor,
                        cdSetor: setor.cdSetor,
                        flNovo: true,
                    })
                }
                
            }

        },
        mounted: function () {
            //this.load();
            const esperaBoootstrap = () => {
                if (window.bootstrap && window.bootstrap.Modal) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadatroUsuarioCliente);
                } else {
                    setTimeout(esperaBoootstrap, 50)
                }
            }
            this.$nextTick(() => esperaBoootstrap());
        },
        watch: {
            showModal: function () {
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadatroUsuarioCliente);
                }
                this.modal.show();

                this.load();
            },
            
        }
        
    };
</script>

<style scoped>
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        z-index: 10;
    }

    .btn-close-modern:hover {
        transform: scale(1.05);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .modal-modern-header .header-icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
        color: #2563eb;
    }

    .modal-modern-header .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .modal-modern-header .header-text p {
        margin-top: 6px;
        margin-bottom: 0;
        color: #475569;
        font-size: 14px;
        max-width: 420px;
        line-height: 1.4;
    }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-modern-primary {
        border: none;
        border-radius: 12px;
        padding: 14px 20px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-modern-primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
    }

    .btn-modern-primary:active {
        transform: translateY(0);
    }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        margin-bottom: 10px;
    }

    .modern-modal .form-control:focus {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
        background: #ffffff;
    }

    .modern-modal select.form-control {
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .modern-modal .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
    }

    .admin-card {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.06) 0%, rgba(0, 208, 132, 0.06) 100%);
        border: 2px solid rgba(31, 123, 255, 0.18);
        border-radius: 16px;
        padding: 20px 22px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        transition: all 0.3s ease;
    }

    .admin-card:hover {
        border-color: rgba(31, 123, 255, 0.35);
        box-shadow: 0 6px 20px rgba(31, 123, 255, 0.18);
    }

    .admin-title {
        font-weight: 700;
        text-transform: uppercase;
        font-size: 13px;
        letter-spacing: 0.5px;
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .admin-checkbox-label {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        position: relative;
        cursor: pointer;
        margin: 0;
        width: fit-content;
    }

    .admin-checkbox-input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .admin-checkbox-custom {
        width: 26px;
        height: 26px;
        border: 2px solid #cbd5e0;
        border-radius: 8px;
        position: relative;
        transition: all 0.3s ease;
        background: #ffffff;
    }

    .admin-checkbox-custom::after {
        content: '';
        position: absolute;
        left: 7px;
        top: 4px;
        width: 7px;
        height: 12px;
        border: solid white;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
        opacity: 0;
        transition: opacity 0.2s ease;
    }

    .admin-checkbox-input:checked ~ .admin-checkbox-custom {
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        border-color: transparent;
        box-shadow: 0 6px 16px rgba(31, 123, 255, 0.35);
    }

    .admin-checkbox-input:checked ~ .admin-checkbox-custom::after {
        opacity: 1;
    }

    .admin-checkbox-label:hover .admin-checkbox-custom {
        border-color: #1f7bff;
        box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.12);
    }

    .admin-checkbox-text {
        font-weight: 600;
        font-size: 15px;
        color: #1f2937;
    }

    .admin-checkbox-hint {
        display: block;
        color: #6b7280;
        font-size: 13px;
        margin-left: 38px;
    }

    .btn-action {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        border: 2px solid;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        cursor: pointer;
        background: white;

        i {
            font-size: 0.9rem;
        }

        &:hover {
            transform: translateY(-2px);
        }

        &:active {
            transform: translateY(0);
        }
    }

    .btn-edit {
        border-color: #1f7bff;

        i {
            color: #1f7bff;
        }

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);

            i {
                color: white;
            }
        }
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

        .modal-modern-header::after {
            left: 20px;
            right: 20px;
        }

        .modal-modern-header .header-icon {
            width: 56px;
            height: 56px;
        }

        .admin-checkbox-hint {
            margin-left: 0;
        }
    }

    @media (max-width: 576px) {
        .modern-modal .modal-dialog {
            margin: 12px;
        }

        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body {
        background: transparent;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-control:focus {
        background: rgba(15, 23, 42, 0.95);
    }

    [data-bs-theme="dark"] .modern-modal select.form-control {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    [data-bs-theme="dark"] .modern-modal .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .admin-card {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.14) 0%, rgba(45, 212, 191, 0.14) 100%);
        border-color: rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .admin-checkbox-text {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .admin-checkbox-hint {
        color: #94a3b8;
    }


    .table-wrapper {
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        overflow: hidden;
        background: #ffffff;
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
    }

    .custom-table {
        width: 100%;
        border-collapse: collapse;
    }

        /*.custom-table thead {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }*/

        .custom-table th,
        .custom-table td {
            padding: 16px 18px;
            border-bottom: 1px solid rgba(148, 163, 184, 0.2);
            font-size: 14px;
            color: #1e293b;
        }

        .custom-table th {
            font-weight: 700;
            text-transform: uppercase;
            font-size: 13px;
            letter-spacing: 0.5px;
            color: #1f2937;
        }

        .custom-table tbody tr:hover {
            background: rgba(59, 130, 246, 0.08);
            transition: background 0.2s ease;
        }

    .user-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 8px 14px;
        border-radius: 999px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        color: #2563eb;
        font-weight: 600;
        border: 1px solid #bfdbfe;
    }

    .status-chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 12px;
        border: 1px solid transparent;
    }

    .status-chip-success {
        background: rgba(16, 185, 129, 0.12);
        color: #047857;
        border-color: rgba(16, 185, 129, 0.35);
    }

    .status-chip-danger {
        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

    .action-cell {
        white-space: nowrap;
    }

    .action-buttons {
        display: inline-flex;
        align-items: center;
        gap: 10px;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #f8fafc;
        color: #1f2937;
    }

        .action-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
    }

    .action-btn-delete {
        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

        .action-btn-delete:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: #ffffff;
            border-color: transparent;
        }

    .empty-state {
        text-align: center;
        padding: 60px 20px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #cbd5e1;
    }

    .empty-title {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    @media (max-width: 768px) {
        .modal-modern-content {
            padding-top: 48px;
        }

        .modal-modern-header {
            padding: 28px 24px 18px;
            flex-direction: column;
        }

        .modal-modern-body {
            padding: 24px;
        }

        .section-header {
            flex-direction: column;
            align-items: stretch;
        }

        .modern-btn {
            width: 100%;
            justify-content: center;
        }

        .card-modern-header,
        .card-modern-body {
            padding-left: 20px;
            padding-right: 20px;
        }

        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

            .custom-table thead {
                display: none;
            }

            .custom-table tr {
                margin-bottom: 16px;
                border-radius: 14px;
                overflow: hidden;
                box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
            }

            .custom-table td {
                border: none;
                border-bottom: 1px solid rgba(148, 163, 184, 0.15);
                padding: 14px 16px;
                text-align: left !important;
            }

                .custom-table td:last-child {
                    border-bottom: none;
                }

                .custom-table td::before {
                    content: attr(data-label);
                    display: block;
                    font-weight: 700;
                    margin-bottom: 6px;
                    text-transform: uppercase;
                    color: #64748b;
                    font-size: 12px;
                }
    }


    /* Estilos das Tabs */
    .tabs-header {
        position: sticky;
        top: 0;
        z-index: 20;
        padding: 0.85rem 1.5rem 0.65rem;
        backdrop-filter: blur(8px);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .nav-tabs {
        border-bottom: none;
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin: 0;
        padding: 0;
        flex-grow: 1;
        justify-content: center;
    }

        .nav-tabs .nav-link {
            border: 1px solid transparent;
            background: rgba(248, 250, 252, 0.75);
            color: #475569;
            font-weight: 600;
            padding: 0.55rem 1.2rem;
            border-radius: 999px;
            display: inline-flex;
            align-items: center;
            gap: 0.45rem;
            transition: all 0.2s ease;
            box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.8);
        }

            .nav-tabs .nav-link:hover {
                background: rgba(37, 99, 235, 0.12);
                color: #1d4ed8;
                box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.25);
            }

            .nav-tabs .nav-link.active {
                background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
                color: #fff;
                box-shadow: 0 12px 26px rgba(37, 99, 235, 0.28);
                border-color: transparent;
            }

    [data-bs-theme="dark"] .tabs-header {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%);
        border-bottom: 1px solid rgba(51, 65, 85, 0.8);
    }

    [data-bs-theme="dark"] .nav-tabs {
        border-bottom: none;
    }

        [data-bs-theme="dark"] .nav-tabs .nav-link {
            background: rgba(30, 41, 59, 0.85);
            color: #cbd5f5;
            box-shadow: inset 0 0 0 1px rgba(51, 65, 85, 0.8);
            border-color: transparent;
        }

            [data-bs-theme="dark"] .nav-tabs .nav-link:hover {
                background: rgba(59, 130, 246, 0.25);
                color: #93c5fd;
                box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.4);
            }

            [data-bs-theme="dark"] .nav-tabs .nav-link.active {
                background: linear-gradient(135deg, #1d4ed8 0%, #10b981 100%);
                color: #f8fafc;
                box-shadow: 0 14px 32px rgba(15, 118, 110, 0.35);
            }


    [data-bs-theme="dark"] .modern-table-card {
        background: linear-gradient(135deg, #1a2236 0%, #111827 100%);
        border-color: rgba(59, 130, 246, 0.2);
        box-shadow: 0 16px 36px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
        border-bottom-color: rgba(148, 163, 184, 0.15);
    }

    [data-bs-theme="dark"] .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(16, 185, 129, 0.25) 100%);
        color: #93c5fd;
        box-shadow: 0 10px 24px rgba(59, 130, 246, 0.25);
    }

    [data-bs-theme="dark"] .header-label {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .header-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 16px 32px rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .modern-table-content {
        background: linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
    }

    [data-bs-theme="dark"] .modern-table-state {
        background: rgba(30, 41, 59, 0.65);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-table-state.empty svg {
            color: #475569;
        }

        [data-bs-theme="dark"] .modern-table-state.empty h5 {
            color: #f9fafb;
        }

        [data-bs-theme="dark"] .modern-table-state.empty p {
            color: #94a3b8;
        }

    [data-bs-theme="dark"] .table-wrapper {
        border-color: rgba(59, 130, 246, 0.16);
        background: rgba(17, 24, 39, 0.8);
    }

    [data-bs-theme="dark"] .custom-table {
        background: transparent;
    }

        [data-bs-theme="dark"] .custom-table th {
            color: #94a3b8;
            border-bottom-color: rgba(148, 163, 184, 0.12);
        }

        [data-bs-theme="dark"] .custom-table td {
            color: #e2e8f0;
            background: rgba(30, 41, 59, 0.65);
            border-bottom-color: rgba(51, 65, 85, 0.8);
        }

        [data-bs-theme="dark"] .custom-table tbody tr:hover {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.16) 0%, rgba(16, 185, 129, 0.16) 100%);
        }

    [data-bs-theme="dark"] .assinante-email {
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .assinante-login {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .badge-ativo {
        background-color: rgba(22, 163, 74, 0.25);
        color: #bbf7d0;
    }

    [data-bs-theme="dark"] .badge-inativo {
        background-color: rgba(185, 28, 28, 0.3);
        color: #fecaca;
    }

    [data-bs-theme="dark"] .action-btn-view {
        box-shadow: 0 16px 28px rgba(16, 185, 129, 0.35);
    }

    [data-bs-theme="dark"] .custom-table td::before {
        color: #9ca3af;
    }

</style>

